import { dataProps } from './properties'

export const setTaskList = (state, payload) => {
    state.list = payload.response    
}    

export const setTaskData = (state, payload) => {
    state.props = payload.response    
    state.show_task_form = true
} 

export const resetTaskData = state => {
    state.props = JSON.parse(JSON.stringify(dataProps))
}

export const resetTaskGroupData = state => {
    state.group_task = []
}

export const closeTaskModal = state => {
    state.show_task_form = false
}

export const closeTaskGroupModal = state => {
    state.show_task_group_form = false
}

export const addNewGroupTaskItemRow = state => {

    let key = 0
    state.group_task.push(JSON.parse(JSON.stringify(dataProps)))

    state.group_task.forEach(element => {
        element.key = key
        key ++
    })

    setTimeout(() => {
        document.getElementById('task_title_'+(key-1)).focus()
    }, 300);
}

export const removeGroupTaskItemRow = (state, payload) => {

    let key = 0

    state.group_task.splice(payload, 1)

    if(state.group_task.length === 0) {
        state.group_task = [JSON.parse(JSON.stringify(dataProps))]
    }

    state.group_task.forEach(element => {
        element.key = key
        key ++
    })

}


// WEBPACK FOOTER //
// ./src/store/modules/tasks/mutations.js